import { gotoDp } from "@/app/csr-src/utils/goto";
import { TagContentVo } from "@/app/csr-src/apis/order/order.interface";

/**
 * 商详跳转
 * @param skuId 商品skuId
 * @param orderTagContentVO 订单打标数据
 */
export const jumpToDp = (skuId: string, jumpParam?: string) => {
  if (!skuId) {
    return;
  }
  const jumpParams = jumpParam ? JSON.parse(jumpParam) : {};
  const jumpUrlParams = new URLSearchParams(jumpParams);
  // 跳转拍卖详情
  if (jumpParams?.auctionId && jumpParams?.channelId) {
    // location.href = `/dp-dutch-auction/${skuId}?${jumpUrlParams}`;
  } else {
    // 跳转普通商详
    gotoDp(skuId);
  }
};
